import { Component, OnInit } from '@angular/core';
import { TextospredefinidosService } from '../_services/textospredefinidos.service';
import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';
import { GlobalEventsManager } from '../_services/globaleventsmanager.service';

@Component({
  selector: 'app-textospredefinidos',
  templateUrl: './textospredefinidos.component.html',
  styleUrls: ['./textospredefinidos.component.css']
})
export class TextospredefinidosComponent implements OnInit {

    //bEquipo: boolean = false;
    bFormTextos: boolean = false;
    idObservacion:any;
    idTipo:any;
    listaObservaciones :any;
    tipoTextoDescripcion = '';
    detalleObservacion: boolean = true;
    iconocerrar: string = 'fa fa-times';
    iconoexpandir: string = 'fa fa-expand';
    expandir: any;

  constructor(private textosPredefinidosService: TextospredefinidosService, private confirmationService: ConfirmationService,private globalEventsManager: GlobalEventsManager) { }



  ngOnInit() {

    this.actualizarBreadcrumb();
  }


  verTipoObservaciones(id_tipo_elemento){

    console.log(id_tipo_elemento);

  }

  getListaObservaciones(id_tipo: number){

    this.bFormTextos = false;
    this.textosPredefinidosService.getListaObservacionesTipo(id_tipo).subscribe(
      data => {
        if (data){
          this.listaObservaciones = data;
     /*     if (data.json().observaciones){
            this.listaObservaciones = data.json().observaciones;
          }*/
          this.idTipo = id_tipo;

          switch(this.idTipo) {
            case 1:
                 this.tipoTextoDescripcion = 'Observaciones';
                break;
            case 2:
                this.tipoTextoDescripcion = 'Hechos relevantes';
                break;
            case 3:
                this.tipoTextoDescripcion = 'Recomendaciones';
                break;
        }

        }
        
      }
    );
  }


  actualizarBreadcrumb(){
  
    let breadcrumb: any = [];

    let item = {
      'path':'#',
      'name': 'Edición de Textos predefinidos'
    };
    breadcrumb.push(item);
    this.globalEventsManager.setNombrePagina(breadcrumb);
  }


  cargarObservacion(id){

    this.idObservacion = id;

  }
  
  muestraFormTexto(id){
 
    this.idObservacion = +id;

    this.bFormTextos = true;
    this.detalleObservacion = false;

  }

  editarTexto(idObservacion:number){
    this.bFormTextos = true;

    this.cargarObservacion(idObservacion);
  }

  nuevoTexto(){
    this.detalleObservacion = false;
    this.editarTexto(0);
  }

  onChangeObservacion(event){

    if(event){
      this.cerrar(1);
      this.getListaObservaciones(this.idTipo);
    }
   }

  onCloseObservacion(event: number){
    this.cerrar(1);
   }
 
 cerrar(nivel:number){

    //le pasamos el nivel al que tiene que ir
    if (nivel <= 1){
      this.bFormTextos = false;
      this.detalleObservacion = true;
      this.getListaObservaciones(this.idTipo);
    }

   }

   confirmDeleteObservacion(idObservacion: number) {
    this.confirmationService.confirm({
        message: '¿Seguro que deseas eliminar la observación?',
        accept: () => {
            this.deleteObservacion(idObservacion);
        }
    });
 }

   deleteObservacion(id){

    this.textosPredefinidosService.deleteObservacion(id).subscribe(
      data => {
        this.getListaObservaciones(this.idTipo);
      });
   }

}



// WEBPACK FOOTER //
// ./src/app/textospredefinidos/textospredefinidos.component.ts